module.exports = __webpack_public_path__ + "static/media/BE EXTC sem II 2025-26.639b4410.pdf";